import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import styled from 'styled-components';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_ERROR_ILLUSTRATION = 'errors/general';
const StyledErrorClass = styled.div.withConfig({
  displayName: "LoadingError__StyledErrorClass",
  componentId: "sc-1rc5m7p-0"
})({
  // .workflow-error, .workflow-not-found, .access-forbidden styles
  textAlign: 'center',
  blockSize: '50vh',
  maxWidth: '450px',
  display: 'block',
  margin: 'auto',
  marginBlockStart: '100px',
  // space token for 100px not available

  // .error-button styles
  '& > button': {
    display: 'block'
  }
});
class LoadingError extends Component {
  constructor(...args) {
    super(...args);
    this.handleErrorRedirect = () => {
      const {
        error,
        isIndex
      } = this.props;
      const is403 = error === 403;
      const is404 = error === 404;
      if (isIndex || is404 || is403) {
        return this.props.history.push('/');
      }
      return window.location.reload();
    };
  }
  render() {
    const {
      error,
      isIndex,
      message
    } = this.props;
    const is403 = error === 403;
    const is404 = error === 404;
    let errorMsg = isIndex ? 'fatalErrors.errorLoadingWorkflows.message' : 'fatalErrors.errorLoadingWorkflow.message';
    let buttonText = 'fatalErrors.errorLoadingWorkflows.link';
    let illustration = DEFAULT_ERROR_ILLUSTRATION;
    if (!isIndex) {
      if (is404) {
        errorMsg = 'fatalErrors.workflowNotFound.message';
        buttonText = 'fatalErrors.workflowNotFound.link';
      } else if (is403) {
        errorMsg = 'fatalErrors.forbidden.message';
        buttonText = 'fatalErrors.forbidden.link';
        illustration = 'lock';
      }
    }
    errorMsg = message || errorMsg;
    return /*#__PURE__*/_jsxs(StyledErrorClass, {
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(Illustration, {
          width: 200,
          name: illustration
        })
      }), /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: errorMsg
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: this.handleErrorRedirect,
        marginBlock: "400",
        marginInline: "auto",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: buttonText
        })
      })]
    });
  }
}
export default withRouter(LoadingError);